export default __webpack_public_path__ + "static/media/Spectrum-TreeView.aacdf85f.png";